import React, { useCallback } from "react";
import _ from "lodash";

import { FVIPDOChecklistItem } from "../../../../utils/models";

import Conditional from "../../../common/conditional";
import classNames from './style.module.scss';
import CustomSection from "../../custom-general/custom-section";

interface Props {
    hasPDO: boolean;
    label: string;
    value: string;
    items: FVIPDOChecklistItem[];
}

const FVIPDOChecklistReport: React.FC<Props> = ({ hasPDO, label, value, items }) => {
    const renderGroupedChecklistItems = useCallback(() => {
        const groupedItems = _.groupBy(items, 'category');

        return (
            <React.Fragment>
                {Object.keys(groupedItems).map(key => {
                    return (
                        <Conditional key={key} isVisible={groupedItems[key].length > 0}>
                            <tr>
                                <td className={classNames.checklistTableCaption} colSpan={5}>
                                    {key}
                                </td>
                            </tr>
    
                            {groupedItems[key].map((item) => (
                                <tr key={item.id}>
                                    <td>{item.id}</td>
                                    <td>{item.label}</td>
                                    <td className={classNames.checklistTableCapitalize} colSpan={2}>{item.value || 'N/A'}</td>
                                </tr>
                            ))}
                        </Conditional>
                    )
                })}
            </React.Fragment>
        )
    }, [items]);

    return ( 
        <CustomSection sectionTitle="Potential Drop Object Checklist">
            <div className="p-1">
                <table className={classNames.checklistTable}>
                    <thead>
                        <tr>
                            <th rowSpan={2}>
                                Item
                            </th>
                            
                            <th rowSpan={2} className={classNames.checklistTableTenderBlueBG}>
                                {label}: {value}
                            </th>
                        </tr>
                        
                        <tr>
                            <th>Has PDO?</th>
                            <th>{hasPDO ? 'Yes' : 'No'}</th>
                        </tr>
                    </thead>

                    <tbody>
                        {renderGroupedChecklistItems()}
                    </tbody>
                </table>
            </div>
        </CustomSection>
    );
};
 
export default FVIPDOChecklistReport;